<div class="detail" *ngIf="input">
    <div class="detail-key">{{ input.key }}</div>
    <div class="detail-description" *ngIf="input.description">
        {{ input.description }}
    </div>
    <div class="detail-value-container" [ngClass]="{ 'detail-value-container-readonly': readonly }">
        <input
            *ngIf="!input.isMultiline"
            class="detail-value"
            [ngClass]="{
                'detail-value-invalid': input.formValue.touched && input.formValue.invalid,
            }"
            [type]="input.isSensitive ? 'password' : 'text'"
            [formControl]="input.formValue"
            [placeholder]="placeholder" />
        <textarea
            *ngIf="input.isMultiline"
            class="detail-value multiline-detail-value"
            [ngClass]="{
                'multiline-detail-value-invalid': input.formValue.touched && input.formValue.invalid,
            }"
            [formControl]="input.formValue"
            [placeholder]="placeholder"></textarea>
        <div class="break"></div>
        <div class="error-message" *ngIf="input.formValue.touched && input.formValue.errors">
            {{ input.formValue.errors | formErrorMessage }}
        </div>
    </div>
</div>
